const TransactionFees = "Transaction Fees";
const CostOfSoldInventory = "Cost of Sold Inventory";
const ShippingCost = "Shipping Cost";

export { TransactionFees, CostOfSoldInventory, ShippingCost };
